'use strict'

import React from 'react'

export default class FAQ extends React.Component {
  constructor () {
    super()

    this.state = {
      faqs: [{
        title: 'Dental Packages',
        questions: [{
          title: 'What is a DMA Dental Package?',
          body: 'It is a special payment plan that allows you to spread the cost of dental treatment by paying $49 - $99 per week. It also gives you a generous saving on the total cost. Once your DMA Dental Package is approved the Contact Centre will notify you how to activate your voucher.'
        }, {
          title: 'What sort of dental treatment is covered by a DMA Dental Package?',
          body: 'You can use your voucher for any dental treatment that you need, including cosmetic dentistry, as long as your DMA dentist can complete the treatment without referring you to another specialist.'
        }, {
          title: 'Can I choose a DMA Dental Package for any amount?',
          body: 'The minimum package is $1000 and the maximum is $10000. Packages are in multiples of $1000 - so the other choices are $2000, $3000 and $5000.'
        }, {
          title: 'My treatment cost is in between these amounts, which should I choose?',
          body: 'You can either choose the lower amount and pay the difference yourself or you can get a package for a higher amount and use the additional credit later.'
        }, {
          title: 'What happens if I don’t use the total value of my DMA voucher?',
          body: 'Your account will remain in credit at the practice and you can use that credit at the same dentist whenever you next need dental work.'
        }, {
          title: 'What if my dental treatment exceeds the value of my voucher?',
          body: 'You can increase the value of your voucher by calling DMA on 1300 787 356. Increases are in multiples of $1000 like the original package.'
        }, {
          title: 'How do I apply for a DMA Dental Package?',
          body: 'You can apply online here or call 1300 787 356.'
        }, {
          title: 'Can I have more than one DMA Dental Package?',
          body: 'Yes, if you need additional treatment, you can add another package.'
        }, {
          title: 'How long do I have to wait after joining before I can start my dental work?',
          body: 'After the successful payment of $198 your dental work can start. You will need to book an appointment at the Dental Practice completing your treatment.'
        }, {
          title: 'When will my dental treatment be completed?',
          body: 'Your dental treatment will be spread across the term of your package as agreed with your dentist after your initial consultation.'
        }, {
          title: 'How do I pay my $49-$99/week payments?',
          body: 'DMA help desk will ask for your bank account or credit card details and will set you up on a weekly direct debit payment.'
        }]
      }, {
        title: 'Savings',
        questions: [{
          title: 'How  do I save with a DMA Dental Package?',
          body:
            <span>
              <p>You save 10.9% so the higher the value of the package, the more you save:</p>
              <p>On a $1000 package you save $109. (You pay $99/week for 9 weeks.)</p>
              <p>On a $2000 package you save $218. (You pay $99/week for 18 weeks.)</p>
              <p>On a $3000 package you save $327. (You pay $99/week for 27 weeks.)</p>
              <p>On a $5000 package you save $545. (You pay $99/week for 45 weeks.)</p>
              <p>Voucher discount not included for Capped Fee prices.</p>
            </span>
        }, {
          title: 'Do I pay any interest on my DMA Dental Package?',
          body: 'No, it is interest-free.'
        }]
      }]
    }
  }

  toggleExpandedFAQ (groupIndex, questionIndex) {
    let { faqs } = this.state

    let question = faqs[groupIndex].questions[questionIndex]
    question.expanded = !question.expanded

    this.setState({faqs})
  }

  render () {
    const { faqs } = this.state

    return (
      <div className='faqs'>
        <h1>Frequently Asked Questions</h1>
        {faqs.map((group, i) =>
          <div key={i}>
            <h3 className='bold primary'>{group.title}</h3>
            <div className='panel-group'>
              {group.questions.map((question, j) =>
                <div
                  className={`panel ${question.expanded ? 'expanded' : ''}`}
                  key={j}>
                  <div
                    className='panel-heading'
                    onClick={() => { this.toggleExpandedFAQ(i, j) }}>
                    <span className='icon-arrow' />
                    <h4>{question.title}</h4>
                  </div>
                  <div className='panel-body'>
                    {question.body}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/assets/faq.js